// key 是对应 JS 执行后在 window 中添加的变量
const jsUrls: { [key: string]: string | string[] } = {
  wx: 'https://m.hellobike.com/resource/helloyun/23756/40ts5_jweixin-1.6.0.js',
  ULink: 'https://g.alicdn.com/jssdk/u-link/index.min.js',
  TianQiApm: [
    'https://m.hellobike.com/npm/@hb/tianqi@7.0.0/lib/ubt.h5.js',
    'https://m.hellobike.com/npm/@hb/tianqi@7.0.0/lib/apm.web.js',
  ],
  HBridge: 'https://m.hellobike.com/npm/hb/hbridge/hbridge.min.js', // 最新版本未同步cdn.落后暂时不用，
  VConsole: 'https://m.hellobike.com/npm/vconsole@3.15.1/dist/vconsole.min.js', // 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js',
};

export const loadScript = (src: string) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = resolve;
    script.onerror = reject;
    script.crossOrigin = 'anonymous';
    script.src = src;
    if (document.head.append) {
      document.head.append(script);
    } else {
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  });

export const loadByKey = (key: string) => {
  // 判断对应变量在 window 是否存在，如果存在说明已加载，直接返回，这样可以避免多次重复加载
  if (window[+key]) {
    return Promise.resolve();
  }
  if (Array.isArray(jsUrls[key])) {
    return Promise.all((jsUrls[key] as string[]).map(loadScript));
  }
  return loadScript(jsUrls[key] as string);
};

// 定义这些方法只是为了方便使用，其实 loadByKey 就够了。
export const WXSDK = () => loadByKey('wx');

export const ULINKSDK = () => loadByKey('ULink');

export const ApmSDK = () => loadByKey('TianQiApm');

// export const HBridgeSDK = () => loadByKey('HBridge');

export const vConsoleSDK = () => loadByKey('VConsole');

// await UBTSDK();
// await APMSDK();
